import { SearchTextFilter, searchTextName } from "@me8eon/searchtext_filters";
import * as sw from 'stopword';

const boosts: readonly string[] = [
    "suggestion_en^2",
    "issue^2",
    "title^2",
    "name^2",
    "description",
    "card_title",
    "short_description^2",
    "text",
    "title_en",
    "title_de",
    "description_en",
    "description_de"
];


export function findSearchTextFilter(filter: SearchTextFilter) {
    // return newFindSearchTextFilter(filter)
    // return oldFindSearchTextFilter(filter)
    return shouldFindSearchTextFilter(filter);
}

export function oldFindSearchTextFilter(filter: SearchTextFilter) {
    const keywords = encodeURIComponent(filter[searchTextName]);
    if (!keywords) return undefined;
    return {
        dis_max: {
            queries: [
                {
                    multi_match: {
                        query: `*${keywords}*`,
                        fields: boosts,
                        type: "best_fields",
                        boost: 1.5,
                        fuzziness: "AUTO",
                    },
                },
                {
                    multi_match: {
                        query: `*${keywords}*`,
                        type: "best_fields",
                        fields: ["index_keywords"],
                        boost: 3,
                    },
                },
                {
                    query_string: {
                        type: "phrase_prefix",
                        default_field: "full_text",
                        query: `*${keywords}*`,
                        boost: 1.5,
                        default_operator: "AND",
                        phrase_slop: 1,
                    },
                },
                {
                    query_string: {
                        query: keywords,
                        boost: 1,
                        default_operator: "OR",
                    },
                },
            ],
        },
    };
}

export function newFindSearchTextFilter(filter: SearchTextFilter) {
    const keywords = filter[searchTextName];
    if (!keywords) return undefined;
    return {
        dis_max: {
            queries: [
                {
                    multi_match: {
                        query: keywords,
                        fields: boosts,
                        type: "best_fields",
                        boost: 1,
                        fuzziness: "AUTO",
                    },
                },
                {
                    multi_match: {
                        query: keywords,
                        type: "best_fields",
                        fields: ["index_keywords"],
                        boost: 3,
                    },
                },
                {
                    query_string: {
                        type: "phrase_prefix",
                        default_field: "full_text",
                        query: keywords,
                        boost: 1.5,
                        default_operator: "AND",
                        phrase_slop: 1,
                    },
                },
                {
                    query_string: {
                        query: keywords,
                        boost: 1,
                        default_operator: "OR",
                    },
                },
            ],
        },
    };
}

const stopWordLangMap: Record<string, string> = {
    "en": "eng",
    "de": "deu",
    "sv": "swe",
    "ro": "rou",
}

export function shouldFindSearchTextFilter(filter: SearchTextFilter) {
    const keywordsOld = filter[searchTextName];
    const lang: string = localStorage.getItem('i18nextLng') || "en";
    const langKey = stopWordLangMap[lang] as keyof typeof sw;
    const changedWord = sw.removeStopwords(keywordsOld.split(" "), sw[langKey] as string[]).join(" ");
    const keywords = changedWord ? changedWord : keywordsOld;
    if (!keywords) return undefined;
    const phrase = `"${keywords}"`;
    return {
        bool: {
            should: [
                {
                    multi_match: {
                        query: keywords,
                        fields: boosts,
                        type: "best_fields",
                        boost: 1,
                        fuzziness: 2,
                    },
                },
                {
                    "match_phrase": {
                        "full_text": {
                            "query": keywords,
                            "slop": 2,
                            "boost": 1.5,
                        },
                    },
                }],
            minimum_should_match: 1,
        },
    };
}
